import { IsNotEmpty, IsOptional } from 'class-validator';
import { Mapper } from '../../../common/ddd/mapper.base';
import { IOrgAnalyticsActivityEnum } from '../../../common/enum/org-analytics-activity/org-analytics-activity.enum';
import { formatDuration } from '../../../common/utils/format-duration.util';
import { ChallengeTimeInAppsEntity } from '../../../core/domain/entities/challenge-insights/challenge-time-in-apps.entity';
import { MetricValueType } from '../../../interface/dtos';
import { GetAccountMetricsInsightChartDataResponse } from '../../../interface/dtos/challenge-insights/get-account-metrics-insight-digital-working-hours-chart-data.response.dto';

export class ChallengeTimeInAppsPersistenceResponseDto {
  @IsOptional()
  [IOrgAnalyticsActivityEnum.Count]: string;
  @IsOptional()
  [IOrgAnalyticsActivityEnum.TotalDuration]: string;
  @IsOptional()
  [IOrgAnalyticsActivityEnum.DayCount]: string;
  @IsOptional()
  [IOrgAnalyticsActivityEnum.WeekCount]: string;
  @IsNotEmpty()
  [IOrgAnalyticsActivityEnum.UserId]: string;
  @IsNotEmpty()
  [IOrgAnalyticsActivityEnum.LocalStartTime]: string;
}

export class ChallengeTimeInAppsChartDataMapper
  implements
    Mapper<
      ChallengeTimeInAppsEntity,
      GetAccountMetricsInsightChartDataResponse
    >
{
  toDomain(
    record: ChallengeTimeInAppsPersistenceResponseDto
  ): ChallengeTimeInAppsEntity {
    return ChallengeTimeInAppsChartDataMapper.toDomain(record);
  }
  static toDomain(
    record: ChallengeTimeInAppsPersistenceResponseDto
  ): ChallengeTimeInAppsEntity {
    const entity = ChallengeTimeInAppsEntity.create({
      value: Number(
        record[IOrgAnalyticsActivityEnum.Count] ??
          record[IOrgAnalyticsActivityEnum.TotalDuration]
      ),
      count: Number(
        record[IOrgAnalyticsActivityEnum.DayCount] ??
          record[IOrgAnalyticsActivityEnum.WeekCount]
      ),
      date: String(record[IOrgAnalyticsActivityEnum.LocalStartTime]),
      userId: String(record[IOrgAnalyticsActivityEnum.UserId]),
    });
    return entity;
  }
  toResponse(
    entity: ChallengeTimeInAppsEntity
  ): GetAccountMetricsInsightChartDataResponse {
    return ChallengeTimeInAppsChartDataMapper.toResponse(entity);
  }
  static toResponse(
    entity: ChallengeTimeInAppsEntity
  ): GetAccountMetricsInsightChartDataResponse {
    return {
      value: entity.value === null ? null : Math.round(entity.avg),
      formattedValue:
        entity.type === MetricValueType.Interactions ||
        entity.type === MetricValueType.UniqueUsers
          ? String(Math.round(entity.avg))
          : formatDuration(entity.avg),
      totalValue: entity.value === null ? null : Math.round(entity.value),
      formattedTotalValue:
        entity.type === MetricValueType.Interactions ||
        entity.type === MetricValueType.UniqueUsers
          ? String(Math.round(entity.value))
          : formatDuration(entity.value),
      date: entity.date.toISOString().split('T')[0],
      uniqueUserCount: entity.userCount,
    };
  }
}
